import { Form, Modal, Button, Select, Divider, DatePicker } from "antd";
import { Download } from "react-feather";
import React, { MouseEvent, useContext, useEffect } from 'react';
import { AppContext } from '../../../context/AppContext';
import moment from "moment";

interface Props {
    onOkCallback: (e: MouseEvent<HTMLElement>) => void;
    open: boolean;
    onClose: (e: MouseEvent<HTMLElement>) => void;
    selectedPartner: any;
}

export const OperationsDownloadReports: React.FC<Props> = ({ open, selectedPartner, onClose }) => {
    const context = useContext(AppContext);
    const { onDownloadOperationsReports } = context;
    const [form] = Form.useForm();
    const [fromDate, setFromDate] = React.useState<any>(null)
    const [toDate, setToDate] = React.useState<any>(null)
    const [disableDownloadCTA, setDisableDownloadCTA] = React.useState(true)


    const handleDownloadPartnersReports = async () => {
        const payload = {
            from: fromDate ? fromDate.format('YYYY-MM-DD') : null,
            to: toDate ? toDate.format('YYYY-MM-DD') : null
        };

        const filename = `Transaction Reports (${payload.from} -  ${payload.to}).csv`;

        try {
            const reports = await onDownloadOperationsReports(payload, selectedPartner.id);
            const blob = new Blob([reports], { type: 'text/csv' });

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;


            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (e) {
            console.error(e);
        } finally {
            return;
        }
    };

    const checkCTAState = React.useCallback(() => {
        if(!fromDate || !toDate) {
            setDisableDownloadCTA(true)
        }

        if(fromDate && toDate) {
            setDisableDownloadCTA(false)
        }
    }, [fromDate, toDate]);
    
    const fromDatePickerDisabledDate = (day: any) => {
        if (toDate) {
          return day > moment().endOf('day') || day > toDate.endOf('day');
        } else {
          return day && day > moment().endOf('day');
        }
      };
    
    const toDatePickerDisabledDate = (day: any) => {
        return day > moment().endOf('day') || day < fromDate.startOf('day');
    };

    const handleFromDateChange = (date: any) => {
        setFromDate(date);
        checkCTAState();
    };

    const handleToDateChange = (date: any) => {
        setToDate(date);
        checkCTAState();
    };

    useEffect(() => {
        checkCTAState();
    }, [fromDate, toDate, checkCTAState]);


    return (
        <Modal
            className="custom-modal"
            title={<div className="custom-modal-title text-neutralBlack-90 text-header4 leading-7 font-poppinsSemiBold">Download Reports</div>}
            open={open}
            onCancel={onClose}
            footer={[
                <div className="flex flex-row-reverse ml-auto">
                    <Button
                        key="back"
                        disabled={disableDownloadCTA}
                        onClick={handleDownloadPartnersReports}
                        className={`text-xs leading-6 font-poppinsMedium
                                    ${disableDownloadCTA
                                        ? 'button-disabled-custom'
                                        : 'border-primary bg-primary text-white hover:bg-primary-hovered hover:text-white active:border-primary-border active:bg-primary-clicked'}`}
                        style={{ alignItems: 'center', display: 'flex', height: 40, marginRight: '24px' }}
                    >
                        <Download size={20} className="h-4 mr-1 -ml-1" />
                        Download
                    </Button>
                    <Button className="mr-2 font-poppinsMedium text-xs leading-6 text-neutralBlack-75 border-neutralWhite-primaryBorder hover:bg-neutralWhite-hovered hover:text-neutralBlack-75 hover:border-neutralWhite-primaryBorder active:border-neutralWhite-border" onClick={onClose} style={{ height: 40 }}>
                        Cancel
                    </Button>
                </div>
            ]}
        >
            <div >
                <Form form={form} initialValues={{ reportType: "General report type" }}>
                    <div className="ml-6 mr-6 mt-5">
                        <label className="text-neutralBlack-90 font-poppinsMedium text-header5 leading-6 required">
                            Report Type
                        </label>
                        <Form.Item
                            name="reportType"
                            className="w-full mt-3 font-poppinsRegular"
                            rules={[{ required: true }]}
                        >
                            <Select
                                placeholder="Select report type"
                                allowClear
                                style={{ fontFamily: 'PoppinsRegular' }}
                            >
                                <Select.Option className="font-poppinsRegular font-light" value="General report type">General report type</Select.Option>
                                <Select.Option className="font-poppinsRegular font-light" value="Earn points" disabled>Earn points</Select.Option>
                            </Select>
                        </Form.Item>
                        <Divider />
                        <label className="text-neutralBlack-90 font-poppinsMedium text-header5 leading-6 required">
                            Choose the range of date to download
                        </label>
                        <div className="mt-5 mb-5 flex justify-between">
                            <div className="w-1/2 pr-2">
                                <label className="block text-neutralBlack-90 font-poppinsRegular font-normal text-body3 required">
                                    From
                                </label>
                                <DatePicker 
                                    className="w-full font-poppinsRegular" 
                                    placeholder="mm/dd/yyyy" 
                                    value={fromDate}
                                    onChange={(date) => handleFromDateChange(date)}
                                    disabledDate={fromDatePickerDisabledDate}
                                />
                            </div>
                            <div className="w-1/2 pl-2">
                                <label className="block text-neutralBlack-90 font-poppinsRegular font-normal text-body3 required">
                                    To
                                </label>
                                <DatePicker 
                                    className="w-full font-poppinsRegular"
                                    placeholder="mm/dd/yyyy"
                                    value={toDate}
                                    onChange={(date) => handleToDateChange(date)}
                                    disabled={fromDate ? false : true}
                                    disabledDate={toDatePickerDisabledDate}
                                />
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        </Modal>
    );
};